export default {
  getDetail: state => state.detail,
  getList: state => state.list,
  getCategory: state => state.condition.category,
  getCondition: state => state.condition,
  getRegisterCategory: state => state.register.category
};
